export const colors = {
  background: "#f4f3ed",
  surface: "#ffffff",
  surfaceSoft: "#f7f8f4",
  border: "rgba(21,34,27,0.1)",
  text: "#15221b",
  textMuted: "#5c6b61",
  primary: "#24553a",
  primaryStrong: "#173524",
  secondary: "#b7c88d",
  danger: "#9e3f3f",
  warning: "#d6b23f",
  info: "#2d6e9f",
};

export const spacing = {
  xs: 6,
  sm: 10,
  md: 16,
  lg: 20,
  xl: 28,
};
